<template>
	<div class="contactTeacher">

			<div v-if="selectInfoStatus">
				<div class="zdls">指导老师：{{list.daili}}</div>
		    <div class="ewm">
				<img class="img-ewm" :src="ewm" />
			</div>
			<div class="wechat">微信号：<span>{{list.wechat}}</span></div>
			<div class="phone">手机号：<span>{{list.phone}}</span></div>
			<div class="line"></div>
			<div class="image">
				<img class="ylslxn" src="../assets/ylslxn.png" />
				
			</div>
			<div class="shuru">
				<div class="input">
					<img class="phone-img" src="../assets/phone.png" />
					<!-- <input class="phone-input" v-model="phonenum" type="number" @focus="huoqu" placeholder="请输入手机号" /> -->
					<input class="phone-input" v-model="phonenum" placeholder="请输入手机号" />
					 <!-- <el-input v-model="phonenum" placeholder="请输入手机号"></el-input> -->
				</div>
				<div class="submit" @click="onSubmit">确定</div>
			</div>
			</div>
			<div style="padding:20px" v-else>
				未找到老师信息，该代理商编码在后台未找到或后台未配置
			</div>
	</div>
</template>

<script>
	var that;
	import {
		insertBuriedPoint,
		selectAgent,
		insertUser
	} from "../api/api.js";
	export default{
		data(){
			return{
				phonenum:'',
				ewm:JSON.parse(localStorage.getItem('agent')).ewm,
				clientTypea:'',
				list:'',
				//找到老师信息
				selectInfoStatus:true,
			}
		},
		mounted() {
			that=this
			if(JSON.parse(localStorage.getItem('agent'))== 'undefined'){
				this.selectInfoStatus = false;
			}

			if(JSON.parse(localStorage.getItem('agent')).dls=="888-1" || JSON.parse(localStorage.getItem('agent')).dls=="888-2"){
			        var dataa={
			        	dls_code:JSON.parse(localStorage.getItem('agent')).dls,
						wechat:JSON.parse(localStorage.getItem('agent')).wechat
			        }
			        selectAgent(dataa).then(res=>{
			        	console.log("lainxi",res)
			        	this.ss=res
			        	// that.list=res.data.data[0]
						that.list=JSON.parse(localStorage.getItem('selectAgent'))
			        	// that.imgage=res.data.data[0]
			        	// that.clientTypea=res.data.clientType
						that.clientTypea= '免费课程pc'
			        		//  this.ewm=require(`../assets/erweima/${res.data.data[0].ewm_adress}${res.data.data[0].ewm_type}`)
			        
			        	console.log("二维码",that.ewm)
			        })  
			}else{
				var dataa={
					dls_code:JSON.parse(localStorage.getItem('agent')).slbs,
					wechat:JSON.parse(localStorage.getItem('agent')).wechat
				}
				selectAgent(dataa).then(res=>{
					console.log("lainxi",res)
					this.ss=res
					// that.list=res.data.data[0]
					that.list=JSON.parse(localStorage.getItem('selectAgent'))
					// that.imgage=res.data.data[0]
					// that.clientTypea=res.data.clientType
					that.clientTypea= '免费课程pc'
					// if(res.data.data[0].dls_code=="300295-1" || res.data.data[0].dls_code=="300297-1" || res.data.data[0].dls_code=="300299-1" ||
					//  res.data.data[0].dls_code=="300301-1" || res.data.data[0].dls_code=="300302-1" || res.data.data[0].dls_code=="101466-1" ||
					//   res.data.data[0].dls_code=="101616-1" || res.data.data[0].dls_code=="101628-1" || res.data.data[0].dls_code=="300303-1" || 
					//    res.data.data[0].dls_code=="300305-1" || res.data.data[0].dls_code=="300306-1" || res.data.data[0].dls_code=="101312-1" ||
					//    res.data.data[0].dls_code=="024009" || res.data.data[0].dls_code=="045207" || res.data.data[0].dls_code=="075303" ||
					// 	res.data.data[0].dls_code=="100006-1" || res.data.data[0].dls_code=="100052-1"){
						// let aa=require(`${ewm_type}`)
						//  this.ewm=require(`../assets/erweima/${res.data.data[0].ewm_adress}${res.data.data[0].ewm_type}`)
					 // }else{ 
						 // this.ewm=require(`../assets/erweima/${res.data.data[0].ewm_adress}.jpg`)
					 // }
					
					
					// that.ewm=ewm
					
					console.log("二维码",that.ewm)
				})
			}
			
			
		},
		methods:{
			onSubmit(){
				if(localStorage.getItem("slbs2") != "undefined" && localStorage.getItem("slbs2") != ''){
					var aa={
					    phone:that.phonenum,
					    gys_name:that.list.dls_name,
					    gys_code:that.list.dls_code,
					    client_type:that.clientTypea,
						kmmc:JSON.parse(sessionStorage.getItem('subjectChoose')).Name,
						gys_code:JSON.parse(localStorage.getItem("agent")).slbs,
						suffix:localStorage.getItem("slbs2"),
					}
				}else{
					var aa={
					    phone:that.phonenum,
					    gys_name:that.list.dls_name,
					    gys_code:that.list.dls_code,
					    client_type:that.clientTypea,
						kmmc:JSON.parse(sessionStorage.getItem('subjectChoose')).Name,
						gys_code:JSON.parse(localStorage.getItem("agent")).slbs,
					}
				}
				
				   insertUser(aa).then(res=>{
				       if(res.msg="提交成功"){
						   console.log("提交成功")
						    this.$message({
						             showClose: true,
						             message: '提交成功',
						             type: 'success'
						           });
					   }
					   
				   })
			}
		}
	}
</script>

<style scoped="scoped">
	.lxls{
		width: 100%;
		height: 580px;
		background-color:  aquamarine;
	}
	.contactTeacher /deep/ .el-input__inner{
		width: 210px;
		outline: none;
		/* border: none; */
		margin-left: 35px;
		margin-top: -50px;
	}
	.zdls{
		width: 100%;
		text-align: center;
		margin-top: 30px;
		margin-bottom: 15px;
		color: #1a1a1a;
		font-size: 16px;
		font-family: Source Han Sans CN Regular, Source Han Sans CN Regular-Regular;
		font-weight: 700;
	}
	.ewm{
		width: 180px;
		height: 180px;
		background-color: #FDBA83;
		margin: auto;
		
	}	
	.img-ewm{
		width: 180px;
		height: 180px;
	}
	.wechat{
		width: 100%;
		text-align: center;
		margin-top: 20px;
		font-weight: 700;
	}
	.phone{
		width: 100%;
		text-align: center;
		margin-top: 10px;
		font-weight: 700;
	}
	.line{
		width: 100%;
		height: 2px;
		opacity: 1;
		margin-top: 20px;
		background: #efeeee;
	}
	.image{
		width: 100%;
		height: 50px;
		text-align: center;
		margin-top: 20px;
		margin-bottom: 30px;
	}
	.ylslxn{
		width: 80%;
		
	}
	.shuru{
		width: 320px;
		height: 45px;
	    
	
		margin:0 auto;
		left:0; 
		right:0;
	}
	.input{
		box-shadow: 0px 0px 6px #c7cfd3;
		width: 260px;
		height: 45px;
        position: relative;
	}	
	.phone-img{
		width: 16px;
		height: 26px;
		
		margin-top: 9px;
		margin-left: 10px;
		
	}
	.phone-input{
		width: 180px;
		height: 30px;
		margin-top: 5px;
		margin-left: 5px;
		border: none;
		outline: none;
	   position: absolute;
		-webkit-appearance: none;
	
	}
	.submit{
		float: right;
		width: 60px;
		height: 45px;
		font-size: 16px;
		margin-top: -45px;
		color: #fff;
		line-height: 45px;
		text-align: center;
		box-shadow: 0px 0px 6px #c7cfd3;
		font-family: Source Han Sans CN Regular, Source Han Sans CN Regular-Regular;
		font-weight: 400;
		background: linear-gradient(#ff7901 0%, #ffa309 100%);
	}
</style>
